import React, { Component } from 'react';
import Axios from 'axios';
import Select from 'react-select';
import PropTypes from 'prop-types';
import MaterialSelect from '../MaterialSelect';
import {
  FormRow, inputId, FormInput, FormCheckbox, FileInput
} from '../Utils';
import { Footer, Spinner } from '../../../common/Modal';

export default class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      isLoading: false,
      selectedNotebook: null,
      selectedSlideshow: null,
    };
    this.changeHandout = this.changeHandout.bind(this);
    this.setDistribution = this.setDistribution.bind(this);
    this.setModule = this.setModule.bind(this);
    this.setMaterial = this.setMaterial.bind(this);
    this.setProgramKitMaterial = this.setProgramKitMaterial.bind(this);
    this.clearHandout = this.clearHandout.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.setUnit = this.setUnit.bind(this);
    this.setDisabledModules = this.setDisabledModules.bind(this);
    this.isSelectAllDisabled = this.isSelectAllDisabled.bind(this);
    this.enableAllModules = this.enableAllModules.bind(this);
  }

  componentDidMount() {
    this.initialState = this.state;
    if (this.props.modelType === 'LessonModule') {
      this.setState({ selectedModules: [this.props.modelId] });
    }
  }

  // add disabled=true property to any module that is already associated with the selected material
  setDisabledModules() {
    const self = this;

    // if material is handout we will allow duplicates so dont disable
    if (this.materialIsHandout()) {
      this.enableAllModules();
      return;
    }

    // we dont want to disable the existing module-material association that we are editing
    const initialModuleId = this.initialState ? this.initialState.modelId : this.state.modelId;
    this.props.allModules.forEach((module) => {
      const disabledModules = self.state.material_modules[self.state.materialId];
      if (disabledModules && disabledModules.includes(module.value) && module.value !== initialModuleId) {
        module.disabled = true;
      }
      else {
        module.disabled = false;
      }
    });
  }

  setMaterial(e) {
    this.setState({
      materialId: e ? e.value : null,
      name: e ? e.label : null,
      modelUnitId: e && e.materialUnitId ? e.materialUnitId : null
    });
  }

  setDistribution(e) {
    this.setState({ distribution: e ? e.value : null });
  }

  setModule(e) {
    if (e && e.length > 0) {
      let modelId = [];
      let selectedModules = [];

      if (e.find(el => el.value === 'all')) {
        modelId = this.props.allModules.map(module => module.value);
        selectedModules = this.props.allModules.filter(module => !module.disabled);
      }
      else {
        modelId = e.map(module => module.value);
        selectedModules = e;
      }
      this.setState({
        modelType: 'LessonModule',
        modelId: modelId,
        selectedModules: selectedModules
      });
    }
    else {
      this.setState({
        modelType: 'Lesson',
        modelId: this.state.lessonId,
        selectedModules: []
      });
    }
  }

  setUnit(e) {
    this.setState({ modelUnitId: e ? e.value : null });
  }

  setProgramKitMaterial(e) {
    this.setState({ programKitMaterial: e });
  }

  enableAllModules() {
    this.props.allModules.forEach((module) => {
      module.disabled = false;
    });
  }

  isSelectAllDisabled() {
    return this.props.allModules.every(module => module.disabled);
  }

  clearForm() {
    this.setState(this.initialState);
  }

  closeModal() {
    this.clearForm();
    this.props.closeModal();
  }

  handleChange(e, stateName) {
    this.setState({
      [stateName]: e.target.value
    });
  }

  handleCheck(e, stateName) {
    this.setState({
      [stateName]: e.target.checked
    });
  }

  handleQuantityChange(e, stateName) {
    const value_string = e.target.value.toString();

    if (value_string.includes('.')) {
      const separated_value = value_string.split('.');
      if (separated_value[1].length > 2) return;
    }

    if (e.target.value === '' || parseInt(e.target.value, 10) > 0) this.handleChange(e, stateName);
  }

  changeHandout(e) {
    this.setState({
      handout: e.target.files[0],
      removeHandout: false
    });
  }

  clearHandout(e) {
    e.target.previousSibling.value = null;
    this.setState({
      handout: null,
      removeHandout: true
    });
  }

  materialIsHandout() {
    return this.state.name === 'Handout';
  }

  determineModelType() {
    const { modelType, selectedNotebook, selectedSlideshow } = this.state;

    if (selectedNotebook) return 'Notebook';
    if (selectedSlideshow) return 'SlideShow';
    if (modelType === 'UnitProject') return 'Unit';

    return modelType;
  }

  _buildFormData() {
    const {
      modelId, materialId, quantity, distribution, additionalInfo, notes, optional, recyclable, programKitMaterial,
      reusable, handoutTitle, handout, removeHandout, modelUnitId, programId, lessonId, unitId, pdfDynamicLessonFooters,
    } = this.state;

    const formData = new FormData();

    const model = this.determineModelType();

    if (removeHandout) formData.append('model_material[delete_handout]', '1');
    if (handout) formData.append('model_material[handout]', handout);
    formData.append('model_material[model_type]', model);
    formData.append('model_material[model_id]', modelId || lessonId || unitId);
    formData.append('model_material[material_id]', materialId);
    formData.append('model_material[measurement_unit_id]', modelUnitId || null);
    formData.append('model_material[program_kit_material_id]', ((programKitMaterial && Object.keys(programKitMaterial).length > 0) ? programKitMaterial.value : ''));
    formData.append('model_material[quantity]', quantity);
    formData.append('model_material[distribution]', distribution);
    formData.append('model_material[additional_information]', additionalInfo);
    formData.append('model_material[notes]', notes || '');
    formData.append('model_material[optional]', optional);
    formData.append('model_material[recyclable]', recyclable);
    formData.append('model_material[reusable]', reusable);
    formData.append('model_material[handout_title]', handoutTitle);
    formData.append('model_material[program_id]', programId);
    formData.append('model_material[pdf_dynamic_lesson_footers]', pdfDynamicLessonFooters);

    return formData;
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ isLoading: true });

    const method = this.props.newRecord ? 'post' : 'put';
    const url = `/admin/model_materials/${this.props.newRecord ? '' : this.props.id}`;
    const callback = this.props.newRecord ? this.props.onAdd : this.props.onUpdate;
    const data = this._buildFormData();

    Axios({ data, method, url }).then((response) => {
      if (response.data.errors) {
        console.log(response.data.errors);
        this.setState({ isLoading: false, error: true });
      }
      else {
        this.setState({ isLoading: false });
        this.props.closeModal();
        callback(response.data);
      }
    }).catch((error) => {
      console.log(error);
      this.setState({ isLoading: false, error: true });
    });
  }

  renderUnitProjectsInput() {
    if (this.props.modelType !== 'UnitProject') return;

    return (
      <FormRow>
        <label
          className="mt5"
          htmlFor="unit-projects-select"
        >
          Projects
        </label>
        <Select
          id="unit-projects-select"
          searchable
          onChange={(notebook) => {
            this.setState({
              modelId: notebook.value,
              selectedNotebook: this.props.unitNotebooks.find(n => n.value === notebook.value),
              selectedSlideshow: null,
            });
          }}
          value={this.state.selectedNotebook?.value}
          options={this.props.unitNotebooks}
        />
      </FormRow>
    );
  }

  renderUnitSlideShowInput() {
    if (this.props.modelType !== 'UnitProject') return;

    return (
      <FormRow>
        <label
          className="mt5"
          htmlFor="unit-slideshow-select"
        >
          Slideshow
        </label>
        <Select
          searchable
          id="unit-slideshow-select"
          options={this.props.unitSlideshows}
          value={this.state.selectedSlideshow?.value}
          onChange={(slideShow) => {
            this.setState({
              modelId: slideShow.value,
              selectedNotebook: null,
              selectedSlideshow: this.props.unitSlideshows.find(n => n.value === slideShow.value)
            });
          }}
        />
      </FormRow>
    );
  }

  renderMaterialsInput() {
    return (
      <FormRow>
        <label htmlFor="material-select" className="mt5">Material</label>
        <MaterialSelect
          id="material-select"
          name="lesson_module_material[material_id]"
          value={this.state.materialId}
          onChange={this.setMaterial}
          options={this.props.forSelect}
        />
      </FormRow>
    );
  }

  renderQuantityRow() {
    return (
      <FormRow>
        <label className="mt5" htmlFor={inputId({ label: 'quantity', newRecord: this.props.newRecord, id: this.props.id })}>Quantity</label>
        <div style={{ alignItems: 'center', display: 'flex', gap: '8px' }}>
          <input
            id={inputId({ label: 'quantity', newRecord: this.props.newRecord, id: this.props.id })}
            required={!this.state.optional}
            step={0.01}
            style={{ width: '70px' }}
            type="number"
            value={this.state.quantity || ''}
            onChange={(e) => this.handleQuantityChange(e, 'quantity')}
          />
          <Select
            searchable
            aria-label="Unit of Measurement"
            options={[{ value: '', label: 'None' }].concat(this.props.units)}
            style={{ minWidth: '120px' }}
            value={this.state.modelUnitId || ''}
            onChange={this.setUnit}
          />
          <span>per</span>
          <Select
            required
            searchable
            aria-label="Distribution"
            options={this.props.distributions}
            style={{ minWidth: '120px' }}
            value={this.state.distribution}
            onChange={this.setDistribution}
          />
        </div>
      </FormRow>
    );
  }

  renderProgramKitInput() {
    const pkm_options = this.props.programKitMaterials
      .filter(pkm => pkm.material_id === this.state.materialId)
      .map(pkm => ({ value: pkm.value, label: pkm.label }));

    return (
      <FormRow>
        <label
          className="mt5"
          htmlFor={inputId({
            label: 'program-kit-materials',
            newRecord: this.props.newRecord,
            id: this.props.id
          })}
        >
          Kit Location
        </label>
        <Select
          searchable
          value={(this.state.programKitMaterial && Object.keys(this.state.programKitMaterial).length > 0) ? this.state.programKitMaterial : ''}
          onChange={this.setProgramKitMaterial}
          options={[{ value: '', label: 'None' }].concat(pkm_options)}
        />
      </FormRow>
    );
  }

  renderModuleInput() {
    if (this.props.modelType === 'UnitProject') return;

    this.setDisabledModules();
    return (
      <FormRow>
        <label
          className="mt5"
          htmlFor={inputId({
            label: 'module',
            newRecord: this.props.newRecord,
            id: this.props.id
          })}
        >
          Module
        </label>
        <Select
          searchable
          multi
          onChange={this.setModule}
          value={this.state.selectedModules || []}
          options={[{ label: 'All', value: 'all', disabled: this.isSelectAllDisabled() }].concat(...this.props.allModules)}
        />
      </FormRow>
    );
  }

  renderHandoutFileInput() {
    return (
      <FileInput
        label="Handout PDF"
        required
        className="handout-pdf"
        id={this.props.id}
        removeFile={this.state.removeHandout}
        file={this.state.handout}
        fileName={this.state.handoutFileName}
        fileUrl={this.state.handoutUrl}
        handleChange={this.changeHandout}
        handleClear={this.clearHandout}
      />
    );
  }

  renderPdfDynamicLessonHeadersField() {
    return (
      <FormCheckbox
        checked={this.state.pdfDynamicLessonFooters}
        onChange={e => this.handleCheck(e, 'pdfDynamicLessonFooters')}
        label="Display Dynamic Lesson Footers"
        tooltipText="When enabled, this will superimpose a footer into the PDF with a copyright statement, page
                     number (centered), lesson number, and lesson title. Please check that the footer for the PDF you
                     upload is empty."
      />
    );
  }

  render() {
    if (this.state.error) {
      return (
        <div className="error">There was an error. Please reload the page and try again.</div>
      );
    }
    return (
      <form
        className={`materials-form ${this.state.isLoading ? 'loading' : ''}`}
        onSubmit={this.handleSubmit}
      >
        {this.renderUnitProjectsInput()}
        {this.renderUnitSlideShowInput()}
        {this.renderMaterialsInput()}
        {this.materialIsHandout() && (
        <FormInput
          label="handout title"
          stateName="handoutTitle"
          value={this.state.handoutTitle}
          id={this.props.id}
          required
          onChange={this.handleChange}
        />
        )}
        {this.materialIsHandout() && this.renderHandoutFileInput()}
        {this.renderQuantityRow()}
        {this.renderModuleInput()}
        {this.renderProgramKitInput()}
        <FormInput
          label="notes"
          stateName="notes"
          value={this.state.notes}
          id={this.props.id}
          InputType="textarea"
          onChange={this.handleChange}
        />
        <FormCheckbox
          checked={this.state.optional}
          onChange={e => this.handleCheck(e, 'optional')}
          label="Optional"
        />
        <FormCheckbox
          checked={this.state.recyclable}
          onChange={e => this.handleCheck(e, 'recyclable')}
          label="Recyclable"
        />
        <FormCheckbox
          checked={this.state.reusable}
          onChange={e => this.handleCheck(e, 'reusable')}
          label="Reusable"
        />
        {this.materialIsHandout() && this.renderPdfDynamicLessonHeadersField()}
        <Footer secondaryButtonCallback={this.closeModal} />
        <Spinner isLoading={this.state.isLoading} />
      </form>
    );
  }
}

Form.defaultProps = {
  additionalInfo: '',
  allModules: [],
  closeModal: null,
  distribution: '',
  distributions: [],
  forSelect: [],
  handout: null,
  handoutFileName: '',
  handoutTitle: '',
  handoutUrl: '',
  id: null,
  lessonId: null,
  materialId: null,
  material_modules: {},
  materials: null,
  modelId: null,
  modelType: null,
  modelUnitId: null,
  modules: [],
  newRecord: false,
  notes: '',
  onAdd: null,
  onUpdate: null,
  optional: false,
  pdfDynamicLessonFooters: false,
  programKitMaterial: {},
  programKitMaterials: [],
  quantity: null,
  recyclable: false,
  removeHandout: false,
  reusable: false,
  selectedModules: [],
  unitId: null,
  unitNotebooks: [],
  unitSlideshows: [],
  units: [],
};

Form.propTypes = {
  additionalInfo: PropTypes.string,
  notes: PropTypes.string,
  allModules: PropTypes.arrayOf(PropTypes.object),
  closeModal: PropTypes.func,
  distribution: PropTypes.string,
  distributions: PropTypes.arrayOf(PropTypes.object),
  forSelect: PropTypes.arrayOf(PropTypes.object),
  // handout: PropTypes.,
  handoutFileName: PropTypes.string,
  handoutTitle: PropTypes.string,
  handoutUrl: PropTypes.string,
  id: PropTypes.number,
  lessonId: PropTypes.number,
  unitId: PropTypes.number,
  materialId: PropTypes.number,
  materials: PropTypes.arrayOf(PropTypes.object),
  modelId: PropTypes.number,
  modelType: PropTypes.string,
  modelUnitId: PropTypes.number,
  modules: PropTypes.arrayOf(PropTypes.object),
  newRecord: PropTypes.bool,
  onAdd: PropTypes.func,
  onUpdate: PropTypes.func,
  optional: PropTypes.bool,
  programKitMaterial: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  programKitMaterials: PropTypes.arrayOf(PropTypes.object),
  quantity: PropTypes.string,
  recyclable: PropTypes.bool,
  removeHandout: PropTypes.bool,
  reusable: PropTypes.bool,
  selectedModules: PropTypes.arrayOf(PropTypes.object),
  unitNotebooks: PropTypes.arrayOf(PropTypes.object),
  unitSlideshows: PropTypes.arrayOf(PropTypes.object),
  units: PropTypes.arrayOf(PropTypes.object),
  material_modules: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.number)),
  pdfDynamicLessonFooters: PropTypes.bool,
};
